module.exports = __webpack_public_path__ + "img/icn_grey_arrow.5d631dde.svg";